import React from 'react'
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { C, MONO, primaryButtonSx } from './tokens'

const paper = { borderRadius: '12px' }
const ghost = { textTransform: 'none', fontWeight: 500, color: C.text, borderRadius: '8px' }

export function CancelDialog({ views, busy, onConfirm, onClose }) {
  const n = views?.length || 0
  const one = n === 1 ? views[0] : null
  return (
    <Dialog open={!!views} onClose={() => !busy && onClose()} maxWidth="xs" fullWidth PaperProps={{ sx: paper }}>
      <DialogTitle sx={{ fontWeight: 700, fontSize: 17, color: C.text }}>
        {one ? <>Cancel <Box component="span" sx={{ fontFamily: MONO }}>#{one.orderNo}</Box>?</> : `Cancel ${n} orders?`}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: 14, color: C.muted }}>
          {one ? 'It leaves' : 'They leave'}{" the active board and can't be reopened from Dispatch. The restaurant sees the cancellation right away."}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={busy} sx={ghost}>Keep {one ? 'order' : 'orders'}</Button>
        <Button
          variant="contained"
          disableElevation
          onClick={onConfirm}
          disabled={busy}
          startIcon={busy ? <CircularProgress size={14} sx={{ color: 'inherit' }} /> : null}
          sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '8px', bgcolor: C.danger, '&:hover': { bgcolor: '#b42318' } }}
        >
          {busy ? 'Cancelling…' : one ? 'Cancel order' : `Cancel ${n} orders`}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

/**
 * A restaurant's own board: its drivers can't take the order, so RushMyFood
 * delivers it. The fee + tip then go to RushMyFood, so the confirm says so.
 */
export function SendToRmfDialog({ views, busy, onConfirm, onClose }) {
  const one = views?.length === 1 ? views[0] : null
  return (
    <Dialog open={!!views} onClose={() => !busy && onClose()} maxWidth="xs" fullWidth PaperProps={{ sx: paper }}>
      <DialogTitle sx={{ fontWeight: 700, fontSize: 17, color: C.text }}>Send to RushMyFood Delivery?</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: 14, color: C.muted }}>
          {one ? (
            <>A RushMyFood driver will deliver order <strong>#{one.orderNo}</strong> instead of your own drivers.</>
          ) : (
            <>RushMyFood drivers will deliver <strong>{views?.length} orders</strong> instead of your own drivers.</>
          )}{' '}
          Any offer still out to your drivers is pulled back, and the delivery fee and tip go to RushMyFood.
        </DialogContentText>
        {one?.address && (
          <Box sx={{ mt: 1.5, fontSize: 12, color: C.muted }}>Dropoff: {one.address.full}</Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={busy} sx={ghost}>Keep waiting</Button>
        <Button
          onClick={onConfirm}
          disabled={busy}
          startIcon={busy ? <CircularProgress size={14} sx={{ color: 'inherit' }} /> : null}
          sx={{ ...primaryButtonSx, px: 2 }}
        >
          {busy ? 'Sending…' : 'Send now'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

/**
 * Sending to a third-party courier network costs money and can only be
 * undone by cancelling on their side — same confirm and wording as before.
 */
export function SendToFdDialog({ views, busy, onConfirm, onClose }) {
  const one = views?.length === 1 ? views[0] : null
  return (
    <Dialog open={!!views} onClose={() => !busy && onClose()} maxWidth="xs" fullWidth PaperProps={{ sx: paper }}>
      <DialogTitle sx={{ fontWeight: 700, fontSize: 17, color: C.text }}>Send to First Delivery?</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: 14, color: C.muted }}>
          {one ? (
            <>Order <strong>#{one.orderNo}</strong> from <strong>{one.restaurant.name}</strong> will be handed to the First Delivery courier network right away.</>
          ) : (
            <><strong>{views?.length} orders</strong> will be handed to the First Delivery courier network right away.</>
          )}{' '}
          Any offer still out to our own drivers is pulled back.
        </DialogContentText>
        {one?.address && (
          <Box sx={{ mt: 1.5, fontSize: 12, color: C.muted }}>Dropoff: {one.address.full}</Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={busy} sx={ghost}>Keep waiting</Button>
        <Button
          onClick={onConfirm}
          disabled={busy}
          startIcon={busy ? <CircularProgress size={14} sx={{ color: 'inherit' }} /> : null}
          sx={{ ...primaryButtonSx, px: 2 }}
        >
          {busy ? 'Sending…' : 'Send now'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
